// AuthContext.js
import React, { createContext, useState, useEffect } from "react";

export const AuthContext = createContext({
  isAuthenticated: false,
  login: () => {},
  logout: () => {},
});

export const AuthProvider = ({ children }) => {
  const [isAuthenticated, setIsAuthenticated] = useState(false);

  useEffect(() => {
    console.log(
      "isAuthenticated(AuthContext) changed, isAuthenticated : ",
      isAuthenticated
    );
  }, [isAuthenticated]);

  const login = () => {
    console.log("logging in(auth context)");
    setIsAuthenticated(true);
  };

  const logout = () => {
    console.log("logging out(auth context)");
    console.log("isAuthenticated : ", isAuthenticated);
    setIsAuthenticated(false);
  };

  return (
    <AuthContext.Provider value={{ isAuthenticated, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
};

//export default AuthProvider;
